import { useCallback, useRef } from 'react';

function focusedElementOf(target: EventTarget | null): HTMLElement | null {
  if (!(target instanceof Node)) return null;
  const focused = target.ownerDocument?.activeElement;
  return focused instanceof HTMLElement ? focused : null;
}

/** A controlled Radix dialog has no trigger to hand focus back to on close
 *  (E2E O7), so the element focused when it opened is remembered and
 *  refocused. Spread the handlers onto DialogContent. */
export function useReturnFocusToOpener() {
  const openerRef = useRef<HTMLElement | null>(null);

  const onOpenAutoFocus = useCallback((event: Event) => {
    openerRef.current = focusedElementOf(event.target);
  }, []);

  const onCloseAutoFocus = useCallback((event: Event) => {
    const opener = openerRef.current;
    if (!opener?.isConnected) return;
    event.preventDefault();
    opener.focus();
  }, []);

  return { onOpenAutoFocus, onCloseAutoFocus };
}
